import { aggregateDeadlines } from '../../../helpers/utils';

export const getDeadlinesReportExcelData = (deadlines: any[]) => {
  const { actions, projects, totalDeadlines } = aggregateDeadlines(deadlines);

  const clientNames = deadlines
    .map((item) => item.client_name)
    .filter((item, index, arr) => arr.indexOf(item) === index)
    .join('; ');

  const aggregateSheet = [
    ['Aggregates'],
    ['Clients', clientNames],
    ['Projects', projects],
    ['Actions', actions],
    ['Total Deadlines', totalDeadlines],
  ];

  const deadlineRows = deadlines.map((d) => [
    d.description || '--',
    d.title || '--',
    d.client_name || '',
    d.funder_name || '',
    d.assignee_name || '--',
    d.deadline || '',
    d.status || '',
  ]);

  const deadlineSheet = [
    [
      'Project Name',
      'Action Name',
      'Client',
      'Funder',
      'Assigned To',
      'Deadline',
      'Status',
    ],
    ...deadlineRows,
  ];

  return [
    { name: 'Aggregates', data: aggregateSheet },
    { name: 'Deadlines', data: deadlineSheet },
  ];
};
